import { defineMessages } from 'react-intl';

export default defineMessages({
    pleAddTheSerThaApp1: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Revenue.Please add the services that apply',
        defaultMessage: 'Please add the services that apply'
    },
    proSer2: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Revenue.Products/Services',
        defaultMessage: 'Products/Services'
    },
    revCalByPer3: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Revenue.Revenue %',
        defaultMessage: '* Revenue (%)'
    },
    subContPercen: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Revenue.Subcontracted(%)',
        defaultMessage: '* Subcontracted(%)'
    },
    add: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Revenue.Add',
        defaultMessage: 'Add'
    },
});